import { gql, useLazyQuery } from "@apollo/client"
import { Company, CompanyCollection, QueryCompaniesArgs } from "@oysterhr/schema"

const ITEMS_PER_PAGE = 25

export const IMPROVED_COMPANY_SELECT_QUERY = gql`
  query UseImprovedCompanySelect(
    $excludeDummy: Boolean
    $perPage: Int
    $withActiveEngagements: Boolean
    $hasPayrollFor: PayrollAttributesInput
    $query: String
    $needsSelectedCompany: Boolean!
    $selectedCompanyId: ID!
    $isClient: Boolean
    $isCustomer: Boolean
    $showPaymentStates: Boolean!
  ) {
    selectedCompany: company(companyId: $selectedCompanyId) @include(if: $needsSelectedCompany) {
      ...CompanyFragment
    }
    companies(
      excludeDummy: $excludeDummy
      withActiveEngagements: $withActiveEngagements
      hasPayrollFor: $hasPayrollFor
      perPage: $perPage
      query: $query
      isClient: $isClient
      isCustomer: $isCustomer
    ) {
      collection {
        ...CompanyFragment
      }
    }
  }
  fragment CompanyFragment on Company {
    id
    name
    avatarUrl
    isCustomer
    isClient
    customer {
      id
      name
    }
    paymentsSettings @include(if: $showPaymentStates) {
      restricted
      flaggedAsFraudster
      badDebtCategory
    }
  }
`

type QueryArgs = QueryCompaniesArgs & {
  /**
   * Use this prop if you want to include the selected company in the list of companies to be returned
   */
  selectedCompanyId?: string
  showPaymentStates: boolean
}

export const useLazyCompaniesSelect = ({ selectedCompanyId, ...args }: QueryArgs) =>
  useLazyQuery<
    { companies: CompanyCollection; selectedCompany?: Company },
    QueryArgs & { needsSelectedCompany?: boolean }
  >(IMPROVED_COMPANY_SELECT_QUERY, {
    variables: {
      ...args,
      perPage: ITEMS_PER_PAGE,
      needsSelectedCompany: !!selectedCompanyId,
      selectedCompanyId: selectedCompanyId || "",
    },
    notifyOnNetworkStatusChange: true,
  })
